/*eslint-disable */
import React, { useState, useEffect, useRef  } from "react";
import {
  Button,
  Modal,
} from "semantic-ui-react";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { Form, TextArea } from 'semantic-ui-react'
import { Form as Formiker, Field, withFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReadAxios from "../axiosComponent/read";
import { translate } from "react-i18next";
import { isEmpty, values } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import Rselect from 'react-select';
import MultiSelect from "react-multi-select-component";
import ReadVAxios from '../axiosComponent/readV';
import UpdateAxios from '../axiosComponent/update';
import DeleteAxios from '../axiosComponent/delete';
import ReadMasterAxios from '../axiosComponent/readMaster'

const PopupModal = (props,{ values, errors, touched, isSubmitting }) => {

  const { t } = props;
  const [optionsBillingPartyBranch, setoptionsBillingPartyBranch] = useState([])
  const [billsPartyBranchSelected, setbillsPartyBranchSelected] = useState([])
  const [billsPartyid, setbillsPartyid] = useState("")

  let handleBillingSelect = (data, e) => {
    setbillsPartyid(data.value);
    getBillingParty(data.value);
    }

    let handleBillingPartyBranch = (data) => {
      setbillsPartyBranchSelected(data)
    }

    let submit = () => {
        billsPartyBranchSelected.map((object, index) => {
            UpdateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/mappings/user_billing_party_branch`, payload: { billingPartyBranchId: object.value, billingPartyId: billsPartyid, mainUserId: props.u_id} }).then((response) => {
                console.log(response);
                let alert = {
                  type: "success",
                  messageHeader: "Success",
                  messageBody: response.data.message,
              };
              props.successAlertDispatcher(alert)
                props.CloseModal(true)
                console.log('props', props);
            }).catch((error) => console.log(error))
        })
    }

    let getBillingParty = (id) => {
        console.log('????getBillingParty', id);
        ReadMasterAxios({ completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_branch`, mainUserId: props.u_id, billingPartyId: id, }).then((response) => {
            console.log('getBranchBillingData',response.data);
            let options = response.data.resultSet
            setoptionsBillingPartyBranch(
                options.map((item, index) => {
                  return {
                    key: index,
                    value: item.billingPartyBranchId,
                    label: item.billingPartyBranchName,
                    raw: { ...item },
                  };
                }))
        }).catch((error) => console.log(error))
    }
    console.log('optionsBillingPartyBranch', optionsBillingPartyBranch);
  return (
    <React.Fragment>
    <Modal
      open={props.OpenModal}
      size="small"
      centered={true}
      scrolling="true"
      onClose={props.CloseModal}
    >
      <Modal.Header>
      <div className="d-flex justify-content-between">
          <label className="mt-2 font-weight-normal">{t("branch.add_billing_party") || "Add Billing Party"}</label>
          <div className="form-inline">
              <i onClick={props.CloseModal} className="fas fa-times"></i>
          </div>
      </div>
      </Modal.Header>
      <Modal.Content scrolling>
      <Formiker>
      <div className="p-3">
        <label>{t("branch.linking_billing_party") || "Linking Billing Party"}</label><br />
        <Rselect
            options={props.optionsBilling}
            defaultOptions
            isSearchable
            onChange={handleBillingSelect}
        />
        <br />
        <label>{t("branch.linking_billing_party_branch") || "Linking Billing Party Branch"}</label><br />
        <MultiSelect
            options={optionsBillingPartyBranch}
            value={billsPartyBranchSelected}
            onChange={handleBillingPartyBranch}
            labelledBy={"Select"} />
    </div>
      </Formiker>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => submit()} primary>
          {t("branch.proceed") || "Proceed"} 
        </Button>
      </Modal.Actions>
    </Modal>
    </React.Fragment>
  );
};

const FormikPopupModal = withFormik({
  mapPropsToValues( {message} ) {
    return {
      message: message || "",
    };
  },
  validationSchema: Yup.object().shape({
    message: Yup.string().required("message Required"),
  }),
  handleSubmit(values, { setErrors, setSubmitting, props}) {
    console.log('props',props);
    console.log(values);
    // getValue(values.message)
    props.CloseModal
    props.textareaValue(values.message)
  },
})(PopupModal);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(translate("create_user")(FormikPopupModal));
